import React, { useState, useEffect } from "react";
import TextBox from "devextreme-react/text-box";
import ValidationGroup from "devextreme-react/validation-group";
import Validator, { RequiredRule } from "devextreme-react/validator";
import Button from "devextreme-react/button";
import "./login-form.scss";
import UserInfo from "../../UserInfo";
import Logo from "../../images/logotrimap.jpg";
import { login } from "../../auth";
import apiAxios from "../../api-axios";
import { useHistory, Link } from "react-router-dom";

const LoginForm = () => {
  const [estado, setEstado] = useState({
    username: "",
    password: "",
    codigoAcesso: "",
    dadosErrados: false,
  });
  const history = useHistory();
  const [sessaoExpirada, setSessaoExpirada] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    setSessaoExpirada(params.get("sessao") === "expirada");
  }, []);

  function onLoginClick(e) {

    console.log("login do app rodando.");
    
    e.preventDefault();
    // if (!args.validationGroup.validate().isValid) {
    //   return;
    // }
    let dados = {
      login: estado.username,
      senha: estado.password,
      sistema: "sgtweb"
    };

    if (estado.codigoAcesso !== "" && estado.codigoAcesso !== undefined) {
      dados.codigoAcesso = parseInt(estado.codigoAcesso);
    }

    apiAxios
      .post("login", dados)
      .then((response) => {
        UserInfo.setUsuario(response.data);
        login(response.data.tokenStr);
        history.push("/home");
        window.location.reload();
      })
      .catch((error) => {
        //notify(error, "error");
        const status = error && error.response && error.response.status;
        setEstado({
          ...estado,
          dadosErrados: typeof status === "number" && status < 500,
        });
      });

    // if (UserInfo.login(estado.username, estado.password)) {
    //   //this.props.onLoginClick(login, password);
    //   //login("@token");
    //   //this.props.history.push("/home");
    // } else {
    //   notify(
    //     {
    //       message: "Login inválido",
    //       width: 150,
    //       position: {
    //         my: "right bottom",
    //         at: "right bottom",
    //         of: window,
    //         offset: "-20 -20",
    //       },
    //     },
    //     "error",
    //     900
    //   );
    // }

    //args.validationGroup.reset();
  }

  function onSignInClick() { }

  return (
    <div className="login-senha-main-div">
      <div className="login-senha-card">
        <form onSubmit={(e) => onLoginClick(e)}>
          <ValidationGroup>
            <div className={"login-header"}>
              <div className={"title"}>
                <img src={Logo} width={250} />
              </div>
              <div>Entre com seu usuário e senha</div>
            </div>
            {sessaoExpirada && (
              <div style={{ textAlign: "center", color: "#b36b00", fontSize: "14px", margin: "4px" }}>
                Sua sessão expirou. Entre de novo.
              </div>
            )}
            <div className={"dx-field"}>
              <TextBox
                value={estado.username}
                onValueChanged={({ value }) =>
                  setEstado({ ...estado, username: value })
                }
                placeholder={"Usuário"}
                width={"100%"}
              >
                <Validator>
                  <RequiredRule message={"Login is required"} />
                </Validator>
              </TextBox>
            </div>
            <div className={"dx-field"}>
              <TextBox
                mode={"password"}
                value={estado.password}
                onValueChanged={({ value }) =>
                  setEstado({ ...estado, password: value })
                }
                placeholder={"Senha"}
                width={"100%"}
              >
                <Validator>
                  <RequiredRule message={"Password is required"} />
                </Validator>
              </TextBox>
            </div>
            <div className={"dx-field"}>
              <TextBox
                value={estado.codigoAcesso}
                onValueChanged={({ value }) =>
                  setEstado({ ...estado, codigoAcesso: value })
                }
                placeholder={"Código de Acesso"}
                width={"100%"}
              ></TextBox>
            </div>
            {/* <div className={'dx-field'}>
        <CheckBox defaultValue={false} text={'Remember me'} />
      </div> */}
            <div
              style={{
                display: estado.dadosErrados ? "flex" : "none",
                justifyContent: "center",
                padding: "1",
                margin: "0.5px",
              }}
            >
              <p
                style={{
                  color: "red",
                  fontSize: "14px",
                  padding: "1px",
                  margin: "1px",
                }}
              >
                Login ou senha inválida!
              </p>
            </div>
            <div className={"dx-field"}>
              <Button
                type={"default"}
                text={"Login"}
                //onClick={(e) => onLoginClick(e)}
                useSubmitBehavior={true}
                width={"100%"}
              />
            </div>

            {/* <div className={'dx-field'}>
        <Link to={'/recovery'} onClick={e => e.preventDefault()}>Perdeu sua senha ?</Link>
      </div> */}
            <div className={"dx-field"}>
              <Button
                type={"normal"}
                text={"Criar nova conta"}
                onClick={() => onSignInClick()}
                width={"100%"}
              />
            </div>
          </ValidationGroup>
          <br />
          <div className={"login-header"}>
            <Link
              style={{
                textAlign: "center",
                justifyContent: "center",
                alignItems: "center",
              }}
              to="recuperar-senha"
            >
              Recuperar senha!
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default LoginForm;
